module.exports = __webpack_public_path__ + "school/img/shou.2b656542.jpg";